import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';
import FormService from '../../../core/services/FormService';
import { throttle } from 'lodash';
import pickBy from 'lodash/pickBy';

class GrammarListService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      grammars: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
    });
  }

  init = action(() => {
    this.grammars = [];
    this.form.reset();
    this.pagination = {
      ...this.pagination,
      current: 1,
    };
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: '/grammars',
        apiVersion: 'v2',
        query: pickBy(
          {
            ...this.form.getValues(),
            ...(this.form.getValue('name') && {
              name: {
                $regex: this.form.getValue('name'),
                $options: 'i',
              },
            }),
            page: this.pagination.current,
            size: this.pagination.pageSize,
            orderDirection: 'ascend',
            orderBy: 'name',
            expand: 'distributor',
          },
          (x) => !!x
        ),
      })
      .then(() => {
        if (this.fetch.data) {
          this.grammars = this.fetch.data.docs;
          this.pagination = { ...this.pagination, total: this.fetch.data.total };
        } else {
          this.grammars = [];
          this.pagination = { ...this.pagination, total: 0 };
        }
      });
  });

  search = throttle(
    action(() => {
      this.pagination.current = 1;
      this.load();
    }),
    500,
    { leading: false }
  );

  handleChange = action((pagination) => {
    this.pagination = { ...this.pagination, ...pagination };
    this.load();
  });

  handleRemove = action((grammar) => {
    ConfirmationDialogService.show(
      'Delete Grammar',
      `You are about to delete the Grammar "${grammar.name}", Do you want to continue ?`,
      () => {
        this.fetch
          .fetch({
            url: `/grammars/${grammar.id}`,
            method: 'delete',
          })
          .then(() => {
            if (this.fetch.data) {
              NotificationService.addNotification(`Grammar "${grammar.name}" deleted successfully.`, 'success');
              this.load();
            }
            if (this.fetch.error) {
              NotificationService.addNotification(this.fetch.error, 'error');
            }
          });
      }
    );
  });
}

const grammarListService = new GrammarListService();

export default grammarListService;
